<template>
  <RouterView />
</template>

<style lang="scss">
@font-face {
  font-family: FavoritPro;
  font-weight: 350;
  src: url("@/assets/fonts/FavoritPro-Book.woff") format("woff");
}

@font-face {
  font-family: FavoritPro;
  font-weight: 400;
  src: url("@/assets/fonts/FavoritPro-Regular.woff") format("woff");
}

@font-face {
  font-family: FavoritPro;
  font-weight: 500;
  src: url("@/assets/fonts/FavoritPro-Medium.woff") format("woff");
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  background-color: #f7f7f7;
  font-family: FavoritPro, sans-serif;
}

.container {
  max-width: 1300px;
  padding: 0 15px;
  margin: 0 auto;

  @media (min-width: 640px) {
    padding: 0 30px;
  }
}

#block-remisetitres-2023-page-title {
  width: 200px;
  margin: 1em auto;
}

.user-login-form {
  width: 200px;
  margin: 0 auto;

  input {
    width: 100%;
    margin-bottom: 1em;
  }
}

#edit-name--description,
#edit-pass--description {
  display: none;
}

#edit-submit {
  width: 100%;
  background: none;
  border: solid 1px #000;
  padding: 5px;
  cursor: pointer;
}
</style>
